@if (!hideSubheader) {
  <div class="sub-header">
    <div class="left-section">
      <!-- Back Arrow -->
      <button
        class="back-button"
        (click)="onBackClick()"
        [title]="
          ComparisonNormalizer.string(originPage) === 'upload'
            ? 'Back to Upload'
            : 'Back to Dashboard'
        "
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.25 9H3.75M3.75 9L9 14.25M3.75 9L9 3.75"
            stroke="#030213"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <!-- Student Name and Details -->
      <div class="student-info">
        <span class="student-name"
          >{{ studentName
          }}<app-salesforce-tag [svgTitle]="salesFlagTitle"></app-salesforce-tag
        ></span>
        <div class="student-details">
          <span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_382_9)">
                <path
                  d="M16.5 6.75L9 3.75L1.5 6.75L9 9.75L16.5 6.75ZM16.5 6.75V11.25"
                  stroke="#013A81"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4.5 7.95117V12.0012C4.5 12.5979 4.97411 13.1702 5.81802 13.5922C6.66193 14.0141 7.80653 14.2512 9 14.2512C10.1935 14.2512 11.3381 14.0141 12.182 13.5922C13.0259 13.1702 13.5 12.5979 13.5 12.0012V7.95117"
                  stroke="#013A81"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_382_9">
                  <rect width="18" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span [title]="studentCourse">
            {{
              studentCourse?.length > 60
                ? (studentCourse | slice: 0 : 60) + ".."
                : studentCourse
            }}
          </span>
          @if (studentId) {
            <span class="separator">|</span>
          }
          @if (studentId) {
            <span>
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_382_16)">
                  <path
                    d="M6 5.25C6 6.04565 6.31607 6.80871 6.87868 7.37132C7.44129 7.93393 8.20435 8.25 9 8.25C9.79565 8.25 10.5587 7.93393 11.1213 7.37132C11.6839 6.80871 12 6.04565 12 5.25C12 4.45435 11.6839 3.69129 11.1213 3.12868C10.5587 2.56607 9.79565 2.25 9 2.25C8.20435 2.25 7.44129 2.56607 6.87868 3.12868C6.31607 3.69129 6 4.45435 6 5.25Z"
                    stroke="#013A81"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.5 14.75V13.25C4.5 12.4544 4.81607 11.6913 5.37868 11.1287C5.94129 10.5661 6.70435 10.25 7.5 10.25H10.5C11.2956 10.25 12.0587 10.5661 12.6213 11.1287C13.1839 11.6913 13.5 12.4544 13.5 13.25V14.75"
                    stroke="#013A81"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_382_16">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
          }
          @if (studentId) {
            <span title="Student Id">{{ studentId }}</span>
          }
          @if (studentYear) {
            <span class="separator">|</span>
          }
          @if (studentYear) {
            <span>
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_382_33)">
                  <path
                    d="M11.25 15.75H4.5C4.10218 15.75 3.72064 15.592 3.43934 15.3107C3.15804 15.0294 3 14.6478 3 14.25V5.25C3 4.85218 3.15804 4.47064 3.43934 4.18934C3.72064 3.90804 4.10218 3.75 4.5 3.75H13.5C13.8978 3.75 14.2794 3.90804 14.5607 4.18934C14.842 4.47064 15 4.85218 15 5.25V8.25"
                    stroke="#013A81"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 2.25V5.25"
                    stroke="#013A81"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 2.25V5.25"
                    stroke="#013A81"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3 8.25H15"
                    stroke="#013A81"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.25 16.5V16.5075"
                    stroke="#013A81"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.25 14.25C14.5862 14.2489 14.9124 14.1351 15.1762 13.9267C15.4401 13.7183 15.6264 13.4275 15.7054 13.1007C15.7844 12.7738 15.7515 12.43 15.6119 12.1241C15.4723 11.8182 15.2341 11.568 14.9355 11.4135C14.6371 11.2607 14.2958 11.2133 13.9671 11.279C13.6384 11.3448 13.3416 11.5199 13.125 11.7758"
                    stroke="#013A81"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_382_33">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
          }
          @if (studentYear) {
            <span title="Program Start Date">{{
              studentYear | date: "MM/dd/yyyy"
            }}</span>
          }
        </div>
      </div>
    </div>
    <div class="right-section"></div>
  </div>
}
